import Swal from 'sweetalert2';
import { get_token } from "@/router";
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';

export default {
mounted() {
  this.getProfileTypes();
  this.preview();
  this.get_question_types();
  this.fetchQuestions().then(() => {
      this.$nextTick(() => {
        $('.table').DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          },
          sortColumn: '',
          sortDirection: 'asc'
        });
      });
    });
},

  data() {
    return ({
        questionDetails: [],
        is_unassigning: false,
        is_ready_to_unassign: false,
        profile_questions: [],  
        selectedQuestions: [],
        get_profile_types: [],
        selectedProfiles: [],
        allSelected: false,
        token_exists: false,
        newQuestion: {
            text: '',
            question_number: '',
            type: '',
            options: [],
            is_mandatory: false
          },
        questions: [],
        question_types: [],
        question_text: '',
        question_type: '',
        isLoading: false,
        newQuestionText: '',
        form:false,
        errors:{},
        answers: {},
      editQuestion: {
        id: null,
        text: '',
        question_number: '',
        type: '', // this will be the type ID
        is_mandatory: false,
        options: [] // { text: 'Option A' }
      },
      });
    },
  components: {
    Sidebar,
    Navbar,
  },
  methods: {
    getToken() {
      return get_token();
    },
    toggleSelectAll(event) {
      this.allSelected = event.target.checked;
      this.selectedQuestions = this.allSelected
        ? this.questions.map((q) => q.id) 
        : [];
    },
    getProfileTypes() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile_types/`, // Replace with the correct endpoint
        method: "GET",
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          this.profileTypes = response.data;
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Failed to Load Profile Types",
            text: "An error occurred while fetching profile types. Please try again.",
          });
        },
      });
    },

    assignQuestions() {
      if (this.selectedProfiles.length === 0) {
        Swal.fire({
          icon: "error",
          title: "No Profile Selected",
          text: "Please select at least one profile type to assign the questions.",
        });
        return;
      }
      const assignmentData = {
        question_ids: this.selectedQuestions,
        profile_type_ids:this.selectedProfiles
      };
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/assign_profile_question/`,
        method: "POST",
        headers: { Authorization: `Token ${this.getToken()}` },
        data: JSON.stringify(assignmentData),
        contentType: "application/json",
        success: (response) => {
          if (response.status == "success") {
          Swal.fire({
            icon: "success",
            title: "Questions Assigned",
            text: "The selected questions have been successfully assigned to the selected profiles.",
            showConfirmButton: false,
            timer: 2000
          });
        }
          this.selectedQuestions = [];
          this.selectedProfiles = [];
          this.allSelected = false;
          $("#assignQuestionsModal").modal('hide')

        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Assignment Failed",
            text: "An error occurred while assigning the questions. Please try again.",
          });
        },
      });
    },
    preview() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
        method: "POST",
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          const questionDetails = response.data.questions.map(question => ({
            question_id: question.id,
            question_name: question.question,
            question_type: question.question_type.question_type
          }));

          this.questionDetails = questionDetails;
          this.$nextTick(() => {
            if (this.dataTableInstance) {
              this.dataTableInstance.destroy();
            }
            this.dataTableInstance = $("#questionsTable").DataTable();
          });
        },
      });
    },
    get_question_types() {
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
        method: "GET",
        headers: { Authorization: `Token ${this.getToken()}` },
        success: (response) => {
          this.question_types = response.data.question_types;
        },
        error: () => {
          Swal.fire({
            icon: "error",
           title: "Failed to load question types",
          });
        }
      });
    },
fetchQuestions() {
  this.token_exists = get_token();
  return new Promise((resolve) => {
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
      method: "POST",
      headers: {
        Authorization: `Token ${this.getToken()}`
      },
      success: (response) => {
        this.questions = response.data.questions;
        resolve();
      },
    });
  });
    },
validate_question() {
  this.errors = {
    newQuestion: {}
  };

  let valid = true;

  if (!this.newQuestion.text || this.newQuestion.text.trim() === '') {
    this.errors.newQuestion.text = "Question text is required.";
    valid = false;
  }
    
  if (!this.newQuestion.type) {
    this.errors.newQuestion.type = "Question type is required.";
    valid = false;
  }

  if (!this.newQuestion.question_number || isNaN(this.newQuestion.question_number)) {
    this.errors.newQuestion.question_number = "Question number is required.";
    valid = false;
  }

  const selected_type = this.question_types.find(t => t.id === this.newQuestion.type);
  if (['checkbox', 'selection'].includes(selected_type?.question_type)) {
    if (!Array.isArray(this.newQuestion.options) || this.newQuestion.options.length === 0) {
      this.errors.newQuestion.options = "At least one option is required.";
      valid = false;
    } else {
      for (let option of this.newQuestion.options) {
        if (!option.text || option.text.trim() === '') {
          this.errors.newQuestion.options = "All options must have text.";
          valid = false;
        }
      }
    }
  }

  return valid;
},

createQuestion() {
  if (!this.validate_question()) {
    return;
  }    

  const formData = new FormData();
  formData.append('question', this.newQuestion.text);
  formData.append('question_type', this.newQuestion.type);
  formData.append('question_number', this.newQuestion.question_number);
  formData.append('is_mandatory', this.newQuestion.is_mandatory);

  const selected_type = this.question_types.find(t => t.id === this.newQuestion.type)?.question_type;    
  if (['checkbox', 'selection'].includes(selected_type)) {
    if (Array.isArray(this.newQuestion.options)) {
      this.newQuestion.options.forEach(option => {
        if (option.text && option.text.trim() !== "") {
          formData.append('options', option.text.trim());
        }
      });
    }
  }

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_question/`,
    method: "POST",
    headers: { Authorization: `Token ${this.getToken()}` },
    data: formData,
    processData: false,
    contentType: false,
    success: (response) => {
      if (response.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Question created",
          text: "The question has been successfully created.",
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          this.fetchQuestions();
          this.resetNewQuestionForm();
        });
      } else {
      }
    },
    error: (xhr, status, error) => {
      console.error("AJAX error:", status, error, xhr.responseText);
    }
  });
},
resetNewQuestionForm() {
  this.newQuestion = {
    text: '',
    question_number: '',
    type: '',
    options: [],
        is_mandatory: false,
      };
    },
    addOption() {
      if (!Array.isArray(this.newQuestion.options)) {
        this.newQuestion.options = [];
      }
    
      const newOption = { id: Date.now(), text: '' };
      this.newQuestion.options.push(newOption);
    },
    
    removeOption(index) {
      this.newQuestion.options.splice(index, 1);
    },

    handle_unassign(){

      this.is_unassigning = true;
      this.is_ready_to_unassign = false;
      this.selectedProfiles = [];
      $("#assignQuestionsModal").modal('show')
    },

    submit_unassign() {

      const originallyAssignedIds = this.profile_questions.map(q => q.question.id);
      const toUnassign = originallyAssignedIds.filter(id => !this.selectedQuestions.includes(id));

      const payload = {
        profile_type_ids: this.selectedProfiles,
        question_ids: toUnassign,
      };
      
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/unassign_profile_question/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status == "success") {
            Swal.fire({
              icon: "success",
              title: "Questions Unassigned",
              text: "The questions  are successfully unassigned",
              showConfirmButton: false,
              timer: 2000
            });
          }
          $("#assignQuestionsModal").modal('hide');
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Unassignment Failed",
            text: "An error occurred while unassigning the questions. Please try again.",
          });
        },
        complete: () => {
          this.is_unassigning = false;
          this.is_ready_to_unassign = false;
          this.selectedProfiles = [];
          this.selectedQuestions = [];
          this.allSelected = false;
          this.fetchQuestions();
        }
      });
    },

    filter_assigned_questions(){
      $("#assignQuestionsModal").modal('hide')
      const payload = {
        filter_values: {
          profile_type_id: this.selectedProfiles,
        },
      };
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/filter_assigned_profile_questions/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          this.profile_questions = response.data;
          
          this.questions = response.data.map(q => q.question);
          this.selectedQuestions = response.data.map(q => q.question.id);
          
          this.is_ready_to_unassign = true;
          
        },
        
        
        
      });
    },



    openEditModal(question) {
      this.editQuestion.id = question.id;
      this.editQuestion.text = question.question;
      this.editQuestion.question_number = question.question_number;
      this.editQuestion.is_mandatory = question.is_mandatory;

      // Get type ID by matching question_type name
      const matchedType = this.question_types.find(
        t => t.question_type === question.question_type?.question_type
      );
      this.editQuestion.type = matchedType ? matchedType.id : '';

      // Map option objects to expected structure
      this.editQuestion.options = question.options?.map(opt => ({ text: opt.value || opt.option })) || [];

      $('#edit_question_modal').modal('show');
    },

    submitEditQuestion() {
      const payload = {
        question_id: this.editQuestion.id,
        update_values: {
          question: this.editQuestion.text,
          question_number: this.editQuestion.question_number,
          question_type: this.editQuestion.type, // ID from dropdown
          is_mandatory: this.editQuestion.is_mandatory, // convert boolean to string
          options: this.editQuestion.options.map(opt => ({ value: opt.text }))
        }
      };

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/update_question/`,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: () => {

          Swal.fire({
            icon: 'success',
            title: 'Updated',
            text: 'Question has been updated.',
            showConfirmButton: false,
            timer: 1000
          });

          $('#edit_question_modal').modal('hide');
          this.refreshQuestions(); // Optional: refresh the list
        }
      });
},
    resetForm() {
      this.edit_question_id = null;
      this.edit_question_text = '';
      this.edit_question_type = '';
      this.edit_question_number = null;
      this.edit_is_mandatory = false;
      this.edit_options = [];
    },

    delete_question(question_id) {
                Swal.fire({
                    title: 'Are you sure?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Continue'
                }).then((result) => {
                    if (result.isConfirmed) {

                        const request_data = JSON.stringify({ question_id: question_id });

                        const headers = {
                            'Authorization': `Token ${this.getToken()}`,
                            'Content-Type': 'application/json'
                        };

                        const url = `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/delete_question/`;

                        $.ajax({
                            type: 'DELETE',
                            url: url,
                            headers: headers,
                            data: request_data,
                            contentType: 'application/json',
                            success: (response) => {
                                if (response.status === "success") {
                                    this.questions = this.questions.filter(m => m.id !== question_id);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Question deleted',
                                        showConfirmButton: false,
                                        timer: 2000
                                    });
                                } else {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Sorry',
                                        text: 'Could not delete question.',
                                        confirmButtonText: 'OK'
                                    });
                                }
                            },
                            error: () => {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Sorry',
                                    text: 'Could not delete question.',
                                    confirmButtonText: 'OK'
                                });
                            }
                        });
                    }
                });
            },

  }
};